module.exports = __webpack_public_path__ + "models/cat_4c59683d59fc039a5cb9d69754c409ad.glb";